import { render, staticRenderFns } from "./AmountBox.vue?vue&type=template&id=56791a28&scoped=true&"
import script from "./AmountBox.vue?vue&type=script&lang=js&"
export * from "./AmountBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56791a28",
  null
  
)

export default component.exports